import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A",
  code: "km",
  messages: {
    alert: {
      close: "\u1794\u17B7\u1791"
    },
    authForm: {
      hidePassword: "\u179B\u17B6\u1780\u17CB\u1796\u17B6\u1780\u17D2\u1799\u179F\u1798\u17D2\u1784\u17B6\u178F\u17CB",
      showPassword: "\u1794\u1784\u17D2\u17A0\u17B6\u1789\u1796\u17B6\u1780\u17D2\u1799\u179F\u1798\u17D2\u1784\u17B6\u178F\u17CB",
      submit: "\u1794\u1793\u17D2\u178F"
    },
    banner: {
      close: "\u1794\u17B7\u1791"
    },
    calendar: {
      nextMonth: "\u1781\u17C2\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB",
      nextYear: "\u1786\u17D2\u1793\u17B6\u17C6\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB",
      prevMonth: "\u1781\u17C2\u1798\u17BB\u1793",
      prevYear: "\u1786\u17D2\u1793\u17B6\u17C6\u1798\u17BB\u1793"
    },
    carousel: {
      dots: "\u1787\u17D2\u179A\u17BE\u179F\u179A\u17BE\u179F\u200B\u179F\u17D2\u179B\u17B6\u1799\u200B\u178A\u17BE\u1798\u17D2\u1794\u17B8\u200B\u1794\u1784\u17D2\u17A0\u17B6\u1789",
      goto: "\u17A1\u17BE\u1784\u1791\u17C5\u179F\u17D2\u179B\u17B6\u1799 {slide}",
      next: "\u1794\u1793\u17D2\u1791\u17B6\u1794\u17CB",
      prev: "\u1798\u17BB\u1793"
    },
    chatPrompt: {
      placeholder: "\u179F\u17BD\u179A\u179F\u17D2\u179A\u17A1\u17B6\u1789\u17CB\u1798\u17BD\u1799\u1794\u17B8\u1793\u17C1\u17C7\u1798\u17B6\u1793\u1794\u17D2\u179A\u1797\u17C1\u1791\u1794\u17B6\u1793\u1791\u17B6\u1798\u1791\u17B6\u179A\u1791\u17C1..."
    },
    chatPromptSubmit: {
      label: "\u179F\u17B6\u1780\u17CB"
    },
    colorMode: {
      dark: "\u1784\u1784\u17B9\u178F",
      light: "\u1797\u17D2\u179B\u17BA",
      switchToDark: "\u1794\u17D2\u178F\u17BC\u179A\u1791\u17C5\u179A\u1794\u17C0\u1794\u1784\u1784\u17B9\u178F",
      switchToLight: "\u1794\u17D2\u178F\u17BC\u179A\u1791\u17C5\u179A\u1794\u17C0\u1794\u1797\u17D2\u179B\u17BA",
      system: "\u1794\u17D2\u179A\u1796\u17D0\u1793\u17D2\u1792"
    },
    commandPalette: {
      back: "\u178F\u17D2\u179A\u17A1\u1794\u17CB",
      close: "\u1794\u17B7\u1791",
      noData: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799",
      noMatch: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u178A\u17C2\u179B\u178F\u17D2\u179A\u17BC\u179C\u1782\u17D2\u1793\u17B6\u1791\u17C1",
      placeholder: "\u179C\u17B6\u1799\u1796\u17B6\u1780\u17D2\u1799\u1794\u1789\u17D2\u1787\u17B6 \u17AC\u179F\u17D2\u179C\u17C2\u1784\u179A\u1780..."
    },
    contentSearch: {
      links: "\u178F\u17C6\u178E\u1797\u17D2\u1787\u17B6\u1794\u17CB",
      theme: "\u179A\u17BC\u1794\u179A\u17B6\u1784"
    },
    contentSearchButton: {
      label: "\u179F\u17D2\u179C\u17C2\u1784\u179A\u1780..."
    },
    contentToc: {
      title: "\u1793\u17C5\u179B\u17BE\u1791\u17C6\u1796\u17D0\u179A\u1793\u17C1\u17C7"
    },
    dashboardSearch: {
      theme: "\u179A\u17BC\u1794\u179A\u17B6\u1784"
    },
    dashboardSearchButton: {
      label: "\u179F\u17D2\u179C\u17C2\u1784\u179A\u1780..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u1794\u1784\u17D2\u179A\u17BD\u1798\u1794\u17B6\u179A\u1785\u17C6\u17A0\u17C0\u1784",
      expand: "\u1796\u1784\u17D2\u179A\u17B8\u1780\u1794\u17B6\u179A\u1785\u17C6\u17A0\u17C0\u1784"
    },
    dashboardSidebarToggle: {
      close: "\u1794\u17B7\u1791\u1794\u17B6\u179A\u1785\u17C6\u17A0\u17C0\u1784",
      open: "\u1794\u17BE\u1780\u1794\u17B6\u179A\u1785\u17C6\u17A0\u17C0\u1784"
    },
    error: {
      clear: "\u178F\u17D2\u179A\u17A1\u1794\u17CB\u1791\u17C5\u1791\u17C6\u1796\u17D0\u179A\u178A\u17BE\u1798"
    },
    fileUpload: {
      removeFile: "\u179B\u17BB\u1794 {filename}"
    },
    header: {
      close: "\u1794\u17B7\u1791\u1798\u17C9\u17BA\u1793\u17BB\u1799",
      open: "\u1794\u17BE\u1780\u1798\u17C9\u17BA\u1793\u17BB\u1799"
    },
    inputMenu: {
      create: '\u1794\u1784\u17D2\u1780\u17BE\u178F "{label}"',
      noData: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799",
      noMatch: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u178A\u17C2\u179B\u178F\u17D2\u179A\u17BC\u179C\u1782\u17D2\u1793\u17B6\u1791\u17C1"
    },
    inputNumber: {
      decrement: "\u1794\u1793\u17D2\u1790\u1799",
      increment: "\u1794\u1784\u17D2\u1780\u17BE\u1793"
    },
    modal: {
      close: "\u1794\u17B7\u1791"
    },
    pricingTable: {
      caption: "\u1794\u1789\u17D2\u1787\u17B8\u178F\u1798\u17D2\u179B\u17C3\u1794\u1793\u17D2\u1791\u1794\u17CB\u1794\u1793\u17D2\u1791\u1794\u17CB"
    },
    prose: {
      codeCollapse: {
        closeText: "\u1794\u1784\u17D2\u179A\u17BD\u1798",
        name: "\u1780\u17BC\u178A",
        openText: "\u1796\u1784\u17D2\u179A\u17B8\u1780"
      },
      collapsible: {
        closeText: "\u179B\u17B6\u1780\u17CB",
        name: "\u179B\u1780\u17D2\u1781\u178E\u17C8\u179F\u1798\u17D2\u1794\u178F\u17D2\u178F\u17B7",
        openText: "\u1794\u1784\u17D2\u17A0\u17B6\u1789"
      },
      pre: {
        copy: "\u1785\u1798\u17D2\u179B\u1784\u1780\u17BC\u178A\u1791\u17C5\u1780\u17D2\u178A\u17B6\u179A\u178F\u1798\u17D2\u1794\u17C0\u178F\u1781\u17D2\u1791\u17B6\u179F\u17CB"
      }
    },
    selectMenu: {
      create: '\u1794\u1784\u17D2\u1780\u17BE\u178F "{label}"',
      noData: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799",
      noMatch: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799\u178A\u17C2\u179B\u178F\u17D2\u179A\u17BC\u179C\u1782\u17D2\u1793\u17B6\u1791\u17C1",
      search: "\u179F\u17D2\u179C\u17C2\u1784\u179A\u1780..."
    },
    slideover: {
      close: "\u1794\u17B7\u1791"
    },
    table: {
      noData: "\u1798\u17B7\u1793\u1798\u17B6\u1793\u1791\u17B7\u1793\u17D2\u1793\u1793\u17D0\u1799"
    },
    toast: {
      close: "\u1794\u17B7\u1791"
    }
  }
});
